module.exports = __webpack_public_path__ + "static/media/Nippon_India_Mutual_Fund.7f45cae9.pdf";